export const COHORT_SORT_PARAMS = {
    FIELD_IDS: {
        TEAM_NAME: "teamName",
        INTERVIEW_QUOTAS: "interviewQuotas",
        INTERVIEWS: "interviews",
        INSIGHTS: "insights",
        HYPOTHESES: "hypotheses",
        VALIDATED_HYPOTHESES: "validatedHypotheses",
        INVALIDATED_HYPOTHESE: "invalidatedHypotheses",
    },
    DIRECTIONS: {
        ASC: "asc",
        DESC: "desc",
    },
};
